export const dataLibL = [{
  word: 'liv',
  partOfSpeech: 'N',
  definition: ['book'],
  egSentenceKw: 'Yo ka li an chay liv.',
  egSentenceEn: 'They read many books.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. livre]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'lanné',
  partOfSpeech: 'N',
  definition: ['year'],
  egSentenceKw: 'Lanné sala kay ni an chay lapli.',
  egSentenceEn: 'This year there will be a lot of rain.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. l\'année]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'losyon',
  partOfSpeech: 'N',
  definition: ['perfume'],
  egSentenceKw: 'Losyon sala ni on bon lòdè.',
  egSentenceEn: 'This perfume has a nice scent.',
  synonym: ['pawfimen'],
  antonym: [null],
  etymology: '[< Fr. lotion]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'linèt',
  partOfSpeech: 'N',
  definition: ['glasses'],
  egSentenceKw: 'Dòktè-a ba li linèt nèf.',
  egSentenceEn: 'The doctor gave her new glasses.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. lunettes]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'lajan',
  partOfSpeech: 'N',
  definition: ['money'],
  egSentenceKw: 'Nonm-lan ni an chay lajan.',
  egSentenceEn: 'The man has lots of money.',
  synonym: ['lenpo'],
  antonym: [null],
  etymology: '[< Fr. l\'argent]',
  dialect: '🇱🇨',
  variant: 'lahan',
}, {
  word: 'li',
  partOfSpeech: 'ART',
  definition: ['the', '(limited usage)'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'la',
  partOfSpeech: 'ADV',
  definition: ['there'],
  egSentenceKw: 'Sa ou ka fè la?',
  egSentenceEn: 'What are you doing there?',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. là]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'la',
  partOfSpeech: 'ADV',
  definition: ['then'],
  egSentenceKw: 'La yo vin konpwann.',
  egSentenceEn: 'Then they understood.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. là]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: '-la',
  partOfSpeech: 'ART',
  definition: ['the', '(conditioned variant)'],
  egSentenceKw: 'I ka manjé fig-la.',
  egSentenceEn: 'She is eating the banana.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. là]',
  dialect: '🇱🇨',
  variant: ['-a', '-an', '-lan'],
}, {
  word: 'lè',
  partOfSpeech: 'N',
  definition: ['time', 'hour'],
  egSentenceKw: 'Ki lè i yé?',
  egSentenceEn: 'What time is it?',
  synonym: ['kon'],
  antonym: [null],
  etymology: '',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: '-lan',
  partOfSpeech: 'ART',
  definition: ['the', '(conditioned variant)'],
  egSentenceKw: 'Nonm-lan ki fè\'y-la té ka pòté on chimiz nwè.',
  egSentenceEn: 'The man who did it was wearing a black shirt.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: ['-an', '-la', '-a'],
}, {
  word: 'lizin',
  partOfSpeech: 'N',
  definition: ['factory'],
  egSentenceKw: 'I ka twavay an lizin-an.',
  egSentenceEn: 'He works in the factory.',
  synonym: ['faktri'],
  antonym: [null],
  etymology: '[< Fr. l\'usine]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'layt',
  partOfSpeech: 'N',
  definition: ['light'],
  egSentenceKw: 'Tenn layt-la!',
  egSentenceEn: 'Turn the light off!',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. light]',
  dialect: '🇱🇨',
  variant: ['limyè'],
}, {
  word: 'limyè',
  partOfSpeech: 'N',
  definition: ['light'],
  egSentenceKw: 'Tout gwan chimen ni limyè apwézan.',
  egSentenceEn: 'All of the main roads have lights now.',
  synonym: ['klèté', 'modisyon'],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'li',
  partOfSpeech: 'PRO',
  definition: ['Third person singular pronoun'],
  egSentenceKw: 'Ba li chèz li.',
  egSentenceEn: 'Give him his chair.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: ['i'],
}, {
  word: 'lanmen',
  partOfSpeech: 'N',
  definition: ['hand'],
  egSentenceKw: 'I lévé lanmen\'y asou papa\'y.',
  egSentenceEn: 'He raised his hand against his father.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. la main]',
  dialect: '🇱🇨',
  variant: ['lenmen'],
}, {
  word: 'lanmen',
  partOfSpeech: 'PREP',
  definition: ['from'],
  egSentenceKw: 'Nou achté tout bagay lanmen\'y.',
  egSentenceEn: 'We bought everything from him.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. la main]',
  dialect: '🇱🇨',
  variant: ['lenmen'],
}, {
  word: 'lèg',
  partOfSpeech: 'N',
  definition: ['eagle'],
  egSentenceKw: 'Lèg-la ka volé.',
  egSentenceEn: 'The eagle is flying.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. l\'aigle]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'lòt',
  partOfSpeech: 'ADJ',
  definition: ['other'],
  egSentenceKw: 'La pa ni pyès lòt mannyè pou fè sa.',
  egSentenceEn: 'There\'s no other way to do that.',
  synonym: ['ka vini', 'pwochen'],
  antonym: ['pasé'],
  etymology: '[< Fr. l\'autre]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'lòt',
  partOfSpeech: 'ADJ',
  definition: ['next'],
  egSentenceKw: 'Lòt simenn nou kay alé Kastwi.',
  egSentenceEn: 'Next week we will go to Castries.',
  synonym: ['ka vini', 'pwochen'],
  antonym: ['pasé'],
  etymology: '[< Fr. l\'autre]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'lapenn',
  partOfSpeech: 'N',
  definition: ['sorrow', 'grief'],
  egSentenceKw: 'Madanm-lan té an lapenn paski ich li té mò.',
  egSentenceEn: 'The woman was in sorrow because her child had died.',
  synonym: ['sonm', 'twis'],
  antonym: ['djé', 'kontan'],
  etymology: '[< Fr. la peine]',
  dialect: '🇱🇨',
  variant: ['an penn'],
},
];

// lapenn
